import { useState, useEffect } from 'react';

const ProgressBar = (props) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    setWidth(`${(props.step / props.total) * 100}%`);
  }, [props.step, props.total]);

  return (
    <div className="ProgressBar">
      <span className="ProgressBar-indicator" style={{ width: `${width}` }}>
        {' '}
      </span>
    </div>
  );
};

export default ProgressBar;
